import { configureStore } from "@reduxjs/toolkit";
import TempDataSlice from "./slices/TempDataSlice";

export const store = configureStore({
  reducer: {
    TempData: TempDataSlice,
  },
});
